// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1156 ? "e509017e" : chunkId) + "." + {"1156":"67c41d07ce060097","2304":"691041022abab270","2769":"06aa3d82184ac79d","9469":"e0236dc5a6b27f95"}[chunkId] + ".js";
};